module.exports = __webpack_public_path__ + "static/media/2.4cb4e37.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/test/2.wav
// module id = NmHS
// module chunks = 0